import { formatMoney } from 'accounting'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faNewspaper } from '@fortawesome/pro-light-svg-icons'

import { Box, ListItem, Text } from '@domain-group/suit-theme'

import useProviderPriceListProductUnlock from '@hooks/useProviderPriceListProductUnlock'

import type { ProviderPriceListProductUnlockModel } from '@domain-group/realhub-backend-api-types'

interface ProviderPriceListProductUnlockProps {
  callbacks: {
    selectLiftover: VoidFunction,
  },
  providerPriceListProductUnlock: ProviderPriceListProductUnlockModel,
  selected: boolean,
}

const ProviderPriceListProductUnlock = (props: ProviderPriceListProductUnlockProps) => {
  const {
    callbacks: {
      selectLiftover,
    },
    providerPriceListProductUnlock,
    selected,
  } = props

  const providerPriceListProductUnlockPayload = useProviderPriceListProductUnlock(providerPriceListProductUnlock)
  const {
    providerPriceListProductUnlock: {
      // @ts-expect-error TS2339
      unlock_price_list_item,
    },
    unlockPriceList,
  } = providerPriceListProductUnlockPayload

  return (
    <ListItem
      borderColor={selected ? 'blue' : 'lineColor'}
      boxProps={{
        border: '1px solid',
        borderRadius: 5,
        paddingY: 'medium',
        marginBottom: 'medium',
      }}
      forceBottomBorder
      onClick={() => selectLiftover()}
    >
      <Box borderRight="1px solid" borderColor="lineColor" justifyContent="center" width="auto">
        <Box
          alignItems="center"
          backgroundColor={selected ? 'blue' : 'whiteGrey'}
          borderRadius={5}
          color={selected ? 'white' : 'blue'}
          flexDirection="column"
          height={40}
          justifyContent="center"
          marginX="medium"
          width={36}
        >
          <FontAwesomeIcon icon={faNewspaper} />
        </Box>
      </Box>

      <Box flexDirection="column" justifyContent="center" marginLeft="medium">
        {/*
         // @ts-expect-error TS2339 */}
        <Text fontSize="small">{unlockPriceList?.title}</Text>
        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
          {formatMoney(unlock_price_list_item?.price)}
        </Text>
      </Box>
    </ListItem>
  )
}

export default ProviderPriceListProductUnlock
